import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import _ from "lodash";
import { Controller, useForm } from "react-hook-form";
import { AuthenticationContext, logUserIn } from "@cloudmlm/cloudmlm-auth";
import {
  Box,
  Button,
  Card,
  Checkbox,
  Grid,
  Stack,
  Typography,
  Link,
  FormHelperText,
  FormControlLabel,
  Menu,
  MenuItem,
} from "@mui/material";
import dataConstant from "../../constants/dataConstants";
import urlConstant from "../../constants/urlConstants";
import {
  DecryptData,
  encryptData,
  httpGet,
  httpPost,
} from "../../services/commonService";
import SignupRefPopup from "../../shared-components/custom-popup/SignupRefPopup";
import SnackState from "../../shared-components/snackbar/snackState";
import CommonSnackBar from "../../shared-components/snackbar/commonSnackbar";
import CustomPhoneField from "../../shared-components/form-controls/customPhoneField";
import CustomAutoCompleteDropdown from "../../shared-components/form-controls/customAutoCompleteDropdown";
import CustomTextField from "../../shared-components/form-controls/customTextField";
import { endApiLoader, startApiLoader } from "../../services/apiLoaderService";
import SignupCompletePopup from "../../shared-components/custom-popup/SignupCompletePopup";
import {
  nameValidator,
  whiteSpaceValidator,
} from "../../shared-components/validator/fieldValidator";
import i18n from "../../i18n";

const locales = {
  en: { title: "English" },
  es: { title: "Spanish" },
};
function AffiliateSignUp() {
  const { t } = useTranslation();
  const authenticationState = useContext(AuthenticationContext);
  const location = useLocation();
  const [snack, closeSnack, showSnackbar] = SnackState();
  const currentLang = i18n.language;
  const navigate = useNavigate();
  const [anchorElLanguage, setAnchorElLanguage] = useState(null);
  const [state, setState] = useState({
    isDisplay: false,
    signupModel: false,
    repModel: false,
    notFoundContent: false,
    RefAccountSiteName: "",
    countryId: 0,
    isAllDropDownCalled: false,
    affiliateUserInfo: {
      uniqueURL: "",
      RefAccountId: "",
      state: {},
      country: {},
      countryData: [],
      stateData: [],
    },
    paymentData: [],
    disabled: false,
    phoneCountryCodeList: [],
    isAventiTrialAccountCreated: false,
    aventiTrialRedirectURL: "",
  });
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const [getURL, setURL] = useState("");
  const [recaptchaError, setRecaptchaError] = useState(false);
  const [isPhoneFiledForceUpdate, setIsPhoneFiledForceUpdate] = useState(true);
  const recaptchaSiteKey = `${process.env.REACT_APP_RECAPTCHA_SITE_KEY}`;
  const [isAventiUser, setIsAventiUser] = useState(false);

  const methods = useForm({
    mode: "all",
    defaultValues: {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      replicaSiteName: "",
      address: "",
      city: "",
      state: null,
      country: null,
      zipcode: "",
      password: "",
      confirmPassword: "",
    },
  });
  const { handleSubmit, setValue, watch, trigger, setFocus, control } = methods;
  const password = watch("password");
  const confirmPassword = watch("confirmPassword");

  const handleRecaptchaChange = (value) => {
    setRecaptchaValue(value);
    setRecaptchaError(false);
  };

  const handlelanguageClick = (event) => {
    setAnchorElLanguage(event.currentTarget);
  };

  const handleLanguageClose = (lang) => {
    setAnchorElLanguage(null);
    if (lang) {
      i18n.changeLanguage(lang);
    }
  };

  useEffect(() => {
    const repURL = window.location.pathname.toLowerCase().split("/");
    const URLrepSiteName1 = repURL.indexOf("affiliatesignup");
    const URLrepSiteName2 = repURL.indexOf("aventiaffiliatesignup");
    if (URLrepSiteName1 !== -1 && URLrepSiteName1 < repURL.length - 1) {
      const name = repURL[URLrepSiteName1 + 1];
      if (name !== "") {
        setURL(name);
        const e = {
          repID: name,
        };
        getREPId(e);
        setState((prevState) => ({
          ...prevState,
          RefAccountSiteName: name,
          countryId: 1,
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          countryId: 1,
        }));
        getREPPopup();
      }
    } else if (URLrepSiteName2 !== -1 && URLrepSiteName2 < repURL.length - 1) {
      setIsAventiUser(true);
      const name = repURL[URLrepSiteName2 + 1];
      if (name !== "") {
        setURL(name);
        const e = {
          repID: name,
        };
        getREPId(e);
        setState((prevState) => ({
          ...prevState,
          RefAccountSiteName: name,
          countryId: 1,
        }));
      } else {
        setState((prevState) => ({
          ...prevState,
          countryId: 1,
        }));
        getREPPopup();
      }
    } else {
      navigate("/login");
    }
  }, []);

  useEffect(() => {
    if (state.countryId !== 0) {
      getAllDropDownList();
    }
  }, [state.countryId]);

  useEffect(() => {
    if (confirmPassword) {
      trigger("confirmPassword");
    }
  }, [password, trigger]);

  useEffect(() => {
    if (state.isAllDropDownCalled) {
      getStateDropDownList(state.countryId);
    }
  }, [state.isAllDropDownCalled]);

  const closeRepModelPopup = () => {
    getRandomREPId();
    setState((prevState) => ({
      ...prevState,
      repModel: false,
    }));
  };

  const getAllDropDownList = () => {
    const dropDownTypes = [dataConstant.AllDropDown.CoutryDropDown];
    const model = {
      DropDownTypes: _.join(dropDownTypes, ","),
    };
    httpPost(urlConstant.Common.GetAllDropDownList, model, true)
      .then((response) => {
        const countryList = response.Value.CoutryDropDownResult.Data;
        const getCountryData = _.find(
          countryList,
          (item) => item.value === state.countryId
        );
        setState((prevState) => ({
          ...prevState,
          isAllDropDownCalled: true,
          affiliateUserInfo: {
            ...prevState.affiliateUserInfo,
            countryData: countryList,
            country: getCountryData !== undefined ? getCountryData : {},
          },
          phoneCountryCodeList: countryList
            .filter((item) => !item.isDisabled)
            .map((item) => item.countryCode?.toLowerCase?.() || ""),
        }));
        if (getCountryData !== undefined) {
          setValue("country", getCountryData);
        }
        setIsPhoneFiledForceUpdate(!isPhoneFiledForceUpdate);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => { });
  };

  const getRandomREPId = async () => {
    const dataModel = {};
    httpPost(urlConstant.IBOSignup.GetRandomReferenceId, dataModel, true)
      .then((response) => {
        if (response.Status !== dataConstant.APIResponseStatus.Failure) {
          setState((prevState) => ({
            ...prevState,
            repModel: false,
            RefAccountSiteName: response.Value.RefName,
            affiliateUserInfo: {
              ...prevState.affiliateUserInfo,
              RefAccountId: response.Value.AccountId,
            },
          }));
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  useEffect(() => {
    if (state.affiliateUserInfo.RefAccountId !== "") {
      setFocus("firstName");
    }
  }, [state.affiliateUserInfo.RefAccountId]);

  const getREPId = async (event) => {
    const dataModel = {
      ReferenceId: event.repID,
    };
    httpPost(urlConstant.IBOSignup.GetReferenceId, dataModel, true)
      .then((response) => {
        if (response.Status === dataConstant.APIResponseStatus.Failure) {
          getREPPopup();
        }
        if (response.Status !== dataConstant.APIResponseStatus.Failure) {
          setState((prevState) => ({
            ...prevState,
            repModel: false,
            RefAccountSiteName: response.Value.RefName,
            affiliateUserInfo: {
              ...prevState.affiliateUserInfo,
              RefAccountId: response.Value.AccountId,
            },
          }));
        } else {
          showSnackbar(response?.error, "error");
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getREPPopup = () => {
    if (
      state.RefAccountSiteName === dataConstant.Undefined ||
      state.RefAccountSiteName === ""
    ) {
      setState((prevState) => ({
        ...prevState,
        repModel: true,
      }));
    }
  };

  const getStateDropDownList = async (countryId, stateId = 0) => {
    if (countryId !== null) {
      await httpGet(
        `${urlConstant.Common.GetStateList}?CountryId=${countryId}`,
        true
      )
        .then((response) => {
          let stateValue = null;
          if (stateId !== 0) {
            stateValue = _.find(response.Value.Data, (i) => {
              return i.value === stateId;
            });
          }
          setState((prevState) => ({
            ...prevState,
            affiliateUserInfo: {
              ...prevState.affiliateUserInfo,
              stateData: response.Value.Data,
              state: stateValue === null ? {} : stateValue,
            },
          }));
          setValue("state", stateValue);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => { });
    }
  };

  const handleCountryChange = (value) => {
    if (value) {
      getStateDropDownList(value.value);
    }
  };

  const formConfig = {
    firstNameParamValueId: {
      name: "firstName",
      label: t("PublicInfo.First Name"),
      isDisabled: location.state?.upgrade,
      required: true,
      type: "text",
      maxLength: 100,
      validation: {
        validate: nameValidator("PublicInfo.First Name"),
      },
    },
    lastNameParamValueId: {
      name: "lastName",
      label: t("PublicInfo.Last Name"),
      isDisabled: location.state?.upgrade,
      required: true,
      type: "text",
      maxLength: 100,
      validation: {
        validate: nameValidator("PublicInfo.Last Name"),
      },
    },
    emailParamValueId: {
      name: "email",
      label: t("PublicInfo.Email Address"),
      isDisabled: location.state?.upgrade,
      type: "email",
      maxLength: 100,
      required: true,
    },
    replicaSiteNameParamValueId: {
      name: "replicaSiteName",
      label: t("SignupCommonField.Common.ReplicatedWebsiteName"),
      isDisabled: location.state?.upgrade,
      type: "text",
      maxLength: 100,
      className: "cm-sitename",
      required: true,
      validation: {
        validate: nameValidator(
          "SignupCommonField.Common.ReplicatedWebsiteName"
        ),
      },
    },
    addressParamValueId: {
      name: "address",
      label: t("SignupCommonField.Common.Address"),
      type: "text",
      maxLength: 200,
      required: true,
      validation: {
        validate: whiteSpaceValidator("SignupCommonField.Common.Address"),
      },
    },
    cityParamValueId: {
      name: "city",
      label: t("SignupCommonField.Common.City"),
      type: "text",
      maxLength: 100,
      required: true,
      validation: {
        validate: whiteSpaceValidator("SignupCommonField.Common.City"),
      },
    },
    stateParamValueId: {
      name: "state",
      label: t("SignupCommonField.Common.State"),
      dropDownList: state.affiliateUserInfo.stateData,
      required: true,
    },
    countryParamValueId: {
      name: "country",
      label: t("SignupCommonField.Common.Country"),
      dropDownList: state.affiliateUserInfo.countryData,
      required: true,
      customOnChange: handleCountryChange,
    },
    zipcodeParamValueId: {
      name: "zipcode",
      label: t("SignupCommonField.Common.ZipCode"),
      type: "text",
      maxLength: 10,
      required: true,
      validation: {
        validate: whiteSpaceValidator("SignupCommonField.Common.ZipCode"),
      },
    },
    passwordParamValueId: {
      name: "password",
      label: t("SignupCommonField.Common.Password"),
      type: "password",
      maxLength: 100,
      required: true,
    },
    confirmPasswordParamValueId: {
      name: "confirmPassword",
      label: t("SignupCommonField.Common.ConfirmPassword"),
      type: "password",
      maxLength: 100,
      required: true,
      validation: {
        validate: (value) =>
          value === password ||
          t(
            "SignupCommonField.Common.Password and confirm password does not match"
          ),
      },
    },
  };

  const onSubmit = (event) => {
    if (!recaptchaValue) {
      setRecaptchaError(true);
      return;
    }
    const model = {
      FirstName: event.firstName,
      LastName: event.lastName,
      PhoneNumber: event.phoneNumber.fullNumber,
      Email: event.email.toLowerCase(),
      SiteName: event.replicaSiteName,
      Password: event.password,
      Address1: event.address,
      City: event.city,
      StateID: event.state ? event.state.value : null,
      CountryID: event.country
        ? event.country[0]
          ? event.country[0].value
          : event.country.value
        : null,
      Zipcode: event.zipcode,
      RefAccountSiteName: getURL
        ? getURL
        : state.affiliateUserInfo.RefAccountId,
      RecaptchaResponse: recaptchaValue,
      SignupFrom: isAventiUser ? "Aventi Signup" : "",
    };
    const createURL = urlConstant.SignUp.AffiliateSignUp;
    httpPost(createURL, model, true)
      .then((response) => {
        if (response.Status === dataConstant.APIResponseStatus.Success) {
          setState((prevState) => ({
            ...prevState,
            signupModel: true,
            isAventiTrialAccountCreated: response?.Values?.IsAventiTrialAccountCreated,
            aventiTrialRedirectURL: response?.Values?.AventiRedirectURL,
          }));
          localStorage.setItem("email", event.email.toLowerCase());
          localStorage.setItem("password", encryptData(event.password));
        } else {
          showSnackbar(response.error);
          return response.error;
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleDashboard = async (goToAventi) => {
    setState((prevState) => ({
      ...prevState,
      isPopupOpen: false,
    }));
    const autoLoginCredentials = {
      username: localStorage.getItem("email"),
      password: DecryptData(localStorage.getItem("password")),
      tokenUrl: process.env.REACT_APP_ROPC_TOKEN_URL,
      grantType: "password",
      scope: `${process.env.REACT_APP_AZURE_AD_B2C_SCOPE} openid offline_access`,
      clientId: process.env.REACT_APP_AZURE_AD_B2C_CLIENTID,
      responseType: "token",
    };
    startApiLoader();
    logUserIn(autoLoginCredentials)
      .then((result) => {
        authenticationState.logUserIn(result);
        const authObject = JSON.parse(localStorage.getItem("auth"));
        if (authObject !== dataConstant.Undefined && authObject !== null) {
          localStorage.setItem("InitialToken", authObject.accessToken);
          if ((goToAventi === "bookNow" || goToAventi === "dashboardAventi") && state.isAventiTrialAccountCreated) {
            navigate("/aventitravel");
            if (goToAventi == "bookNow") {
              handleOpenNewPage(state.aventiTrialRedirectURL);
            }
          } else {
            navigate("/home");
          }
        }
        endApiLoader();
        console.log("Auto-login successful");
      })
      .catch((e) => {
        console.error("Auto-login failed:", e);
      });
  };

  const handleOpenNewPage = (redirectURL) => {
    const newWindow = window.open();
    if (newWindow) {
      newWindow.document.write(redirectURL);
      newWindow.document.close();
    } else {
      alert("Please allow popups to open the redirect page.");
    }
  };

  return (
    <>
      <Box flexDirection={"column"} gap={"20px"} display={"flex"}>
        <Box width={"100%"}>
          <Card
            sx={(theme) => ({
              p: {
                xs: "20px",
                sm: "25px 30px",
              },
              background: "rgba(var(--black-rgb), 0.2)",
              backdropFilter: "blur(50px)",
              border: "1px solid var(--headerbg)",
              borderRadius: "20px",
              borderTopLeftRadius: "0",
              borderTopRightRadius: "0",
              height: "100%",
            })}
          >
            <Stack gap={"20px"}>
              <Grid container spacing={2}>
                <Stack
                  gap={2}
                  direction={"row"}
                  flexWrap={"wrap"}
                  alignItems={"center"}
                  width={"100%"}
                >
                  {isAventiUser ? (
                    <img
                      src={`${process.env.REACT_APP_BLOB_URL}/backoffice-assets/website-logos/AventiLogo-White.png`}
                      alt="Aventi Logo" style={{ width: "150px", height: "auto" }}
                    />
                  ) : (
                    <img
                      src={`${process.env.REACT_APP_BLOB_URL}/backoffice-assets/logo-header.svg`}
                      alt="logo"
                    />
                  )}
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={handlelanguageClick}
                  >
                    {currentLang.toUpperCase()}
                  </Button>
                  <Typography
                    color="secondary.light"
                    variant="h4"
                    fontWeight={600}
                  >
                    {isAventiUser ? t("SignupCommonField.AffiliateSignUp.AventiTitle") : t("SignupCommonField.AffiliateSignUp.Title")}
                  </Typography>
                  <Typography variant="h4" color="primary.main">
                    {t(isAventiUser ? "SignupCommonField.Common.AffiliateName" : "SignupCommonField.Common.IBOName")}
                    {state.RefAccountSiteName}
                  </Typography>
                </Stack>
              </Grid>
            </Stack>
          </Card>
        </Box>
        <Grid container spacing={3} sx={{ flexGrow: 1, marginBottom: "20px" }}>
          <Grid mx={"auto"} size={{ xs: 12, sm: 10 }}>
            <Card
              sx={(theme) => ({
                p: {
                  xs: "20px",
                  sm: "25px 30px",
                },
                background: theme.palette.background.cardGradient,
                border: "1px solid var(--headerbg)",
                borderRadius: "20px",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
              })}
            >
              <Stack gap={1}>
                <Typography variant="h4" fontWeight={800} color="primary">
                  {t("SignupCommonField.IBOSignup.WelcomeTitle")}
                </Typography>
                <Typography variant="body1" color="secondary.light">
                  {t(isAventiUser ? "SignupCommonField.IBOSignup.AventiWelcomeNote" : "SignupCommonField.IBOSignup.WelcomeNote1")}
                </Typography>
              </Stack>

              <Typography variant="h5" fontWeight={800} color="secondary.light">
                {t("SignupCommonField.Common.ContactInformation")}
              </Typography>
              <form noValidate onSubmit={handleSubmit(onSubmit)}>
                <Stack gap={"20px"}>
                  <Grid container spacing={"20px"}>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <CustomTextField
                        methods={methods}
                        properties={formConfig.firstNameParamValueId}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <CustomTextField
                        methods={methods}
                        properties={formConfig.lastNameParamValueId}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <CustomTextField
                        methods={methods}
                        properties={formConfig.emailParamValueId}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <CustomPhoneField
                        control={control}
                        isPhoneFiledForceUpdate={isPhoneFiledForceUpdate}
                        name="phoneNumber"
                        label={t("PublicInfo.Phone Number")}
                        required={true}
                        countryList={state.phoneCountryCodeList}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <Stack
                        className={`customfield-label ${isAventiUser ? "input-extra-label" : ""}`}
                        sx={{
                          maxWidth: "700px",
                          width: "100%",
                          flexDirection: "row",
                          alignItems: "flex-start",
                        }}
                      >
                        <CustomTextField
                          methods={methods}
                          properties={formConfig.replicaSiteNameParamValueId}
                        />
                        <Card
                          className="customfield-label-inner"
                          sx={{
                            marginTop: "21px",
                            display: {
                              xs: "none !important",
                              sm: "flex !important",
                            },
                          }}
                        >
                          {isAventiUser ? process.env.REACT_APP_AVENTITRAVEL_DOMAIN_NAME : process.env.REACT_APP_BYLD_DOMAIN_NAME}
                        </Card>
                      </Stack>
                      <Typography
                        variant="body2"
                        sx={{ fontSize: "10px" }}
                        color="secondary.main"
                      >
                        {t(isAventiUser ? "SignupCommonField.Common.AventiTravelReplicaNoteMessage" : "SignupCommonField.Common.ReplicaNoteMessage" )}
                      </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <CustomAutoCompleteDropdown
                        methods={methods}
                        properties={formConfig.countryParamValueId}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <CustomTextField
                        methods={methods}
                        properties={formConfig.passwordParamValueId}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <CustomTextField
                        methods={methods}
                        properties={formConfig.confirmPasswordParamValueId}
                      />
                    </Grid>

                    <Grid size={{ xs: 12, sm: 6 }}>
                      <CustomTextField
                        methods={methods}
                        properties={formConfig.addressParamValueId}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <CustomAutoCompleteDropdown
                        methods={methods}
                        properties={formConfig.stateParamValueId}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <CustomTextField
                        methods={methods}
                        properties={formConfig.cityParamValueId}
                      />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <CustomTextField
                        methods={methods}
                        properties={formConfig.zipcodeParamValueId}
                      />
                    </Grid>
                  </Grid>

                  <Controller
                    name="terms"
                    control={control}
                    rules={{
                      required: t("SignupCommonField.Common.CheckboxRequired"),
                    }}
                    render={({ field, fieldState: { error } }) => (
                      <Stack direction={"column"} gap={0}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              {...field}
                              checked={!!field.value}
                              color="primary"
                            />
                          }
                          label={
                            <Typography variant="body2" color="secondary">
                              {t(
                                "SignupCommonField.AffiliateSignUp.CheckboxTermCondition"
                              )}{" "}
                              <Link
                                href={`${process.env.REACT_APP_BLOB_URL}/byldNetworkPolicy/IBOTermsAndConditions.pdf`}
                                underline="hover"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {t(
                                  "SignupCommonField.AffiliateSignUp.TermsAndConditions"
                                )}
                              </Link>{" "}
                              {t("SignupCommonField.AffiliateSignUp.and the")}{" "}
                              <Link
                                href={`${process.env.REACT_APP_BLOB_URL}/byldNetworkPolicy/PrivacyPolicy.pdf`}
                                underline="hover"
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {t(
                                  "SignupCommonField.AffiliateSignUp.PrivacyNotice"
                                )}
                              </Link>
                            </Typography>
                          }
                        />
                        {error && (
                          <FormHelperText sx={{ mt: "0px" }} error>
                            {error.message}
                          </FormHelperText>
                        )}
                      </Stack>
                    )}
                  />
                  <Stack direction={"column"} gap={0}>
                    <ReCAPTCHA
                      sitekey={recaptchaSiteKey}
                      onChange={handleRecaptchaChange}
                    />
                    {recaptchaError && (
                      <Typography sx={{ fontSize: "12px" }} color="error">
                        {t("SignupCommonField.AffiliateSignUp.RecaptchaError")}
                      </Typography>
                    )}
                  </Stack>
                  <Stack
                    direction={"row"}
                    width={"100%"}
                    justifyContent={"flex-start"}
                  >
                    <Button
                      type="submit"
                      variant="contained"
                      sx={{ px: 3 }}
                      color="primary"
                    >
                      {t("SignupCommonField.AffiliateSignUp.SignUpButtonText")}
                    </Button>
                  </Stack>
                </Stack>
              </form>
            </Card>
          </Grid>
        </Grid>
      </Box>

      <CommonSnackBar snackObj={snack} closeSnack={closeSnack} buttonProp />

      <SignupRefPopup
        open={state.repModel}
        onClose={() => closeRepModelPopup()}
        onGetRefName={(e) => getREPId(e)}
      />
      <SignupCompletePopup
        open={state.signupModel}
        onClose={(goToAventi) => handleDashboard(goToAventi)}
        onCloseIcon={() => navigate("/login")}
        isAventiAccountCreated={state.isAventiTrialAccountCreated}
      />

      <Menu
        anchorEl={anchorElLanguage}
        open={Boolean(anchorElLanguage)}
        onClose={() => handleLanguageClose()}
      >
        {Object.entries(locales).map(([lang, { title }]) => (
          <MenuItem
            key={lang}
            selected={lang === currentLang}
            onClick={() => {
              handleLanguageClose(lang);
            }}
          >
            {title}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default AffiliateSignUp;